/**
 * Visão de um dia (decisão 6 do dono): só a lista, sem percentual — num dia
 * só a variação é grande demais para ocupação dizer alguma coisa. Ambientes
 * com entrega naquele dia e os terminados naquele dia, com atalho para o
 * Mapa da Produção.
 */
import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";

import { plural } from "../../utils/dinheiro";
import { dataCompleta, montarDia } from "./apresentacao";
import ItemAmbiente from "./ItemAmbiente";
import { Bloco, Campos, ListaRecuada, ListaSimples, Regua, Vazio } from "./styles";

function ListaDoDia({ titulo, itens, vazio, meta, mostrarCamada, podeAbrir, onAbrir }) {
  return (
    <Bloco>
      <h2>
        {titulo} <span>{itens.length}</span>
      </h2>
      {itens.length === 0 ? (
        <Vazio>{vazio}</Vazio>
      ) : (
        <ListaRecuada>
          <ListaSimples>
            {itens.map((item, i) => (
              <ItemAmbiente
                key={item.identidade || `${item.chave}-${i}`}
                item={item}
                meta={meta(item)}
                mostrarCamada={mostrarCamada}
                podeAbrir={podeAbrir}
                onAbrir={onAbrir}
              />
            ))}
          </ListaSimples>
        </ListaRecuada>
      )}
    </Bloco>
  );
}

export default function VisaoDia({ painel, hoje, podeVerMapa, podeAbrir, onAbrir }) {
  const [dia, setDia] = useState(hoje);
  const { entregas, terminados } = useMemo(() => montarDia(painel, dia), [painel, dia]);

  return (
    <>
      <Campos>
        <label>
          Dia
          <input type="date" value={dia} onChange={(evento) => setDia(evento.target.value || hoje)} />
        </label>
        {podeVerMapa ? (
          <Link to="/legado/mapa" className="btn btn--secondary btn--sm">
            Abrir no Mapa da Produção
          </Link>
        ) : null}
      </Campos>
      <Regua>
        {dataCompleta(dia)}: {plural(entregas.length, "ambiente", "ambientes")} com entrega e{" "}
        {plural(terminados.length, "terminado", "terminados")}. Num dia só não há percentual: a variação diária é
        grande demais para dizer quanto da capacidade está tomada.
      </Regua>
      <ListaDoDia
        titulo="Com entrega neste dia"
        itens={entregas}
        vazio="Nenhum ambiente em aberto com entrega neste dia."
        meta={() => null}
        mostrarCamada
        podeAbrir={podeAbrir}
        onAbrir={onAbrir}
      />
      <ListaDoDia
        titulo="Terminados neste dia"
        itens={terminados}
        vazio="Nenhum término lançado neste dia."
        meta={() => "terminado"}
        podeAbrir={podeAbrir}
        onAbrir={onAbrir}
      />
    </>
  );
}
